import Vue from 'vue'
import App from './App.vue'
import Router from './router'
import Store from './store/store'
import MQ from 'vue-match-media/src'
import VueClickOutside from 'v-click-outside'
import VueResize from 'vue-resize'
import VuejsDialog from 'vuejs-dialog';
import Toasted from 'vue-toasted';
// import SmdScaffolding from 'smd-vue-scaffold';

// import 'smd-vue-scaffold/dist/smd-vue-scaffold.min.css'

import './scaffolding/scaffolding'
import 'vue-resize/dist/vue-resize.css'

import './filters/computeAge'
import './filters/dateFormatFilter'
import './filters/getValueByKey'

import './ObjectUtility/cloneObject'
import 'vuejs-dialog/dist/vuejs-dialog.min.css';

Vue.config.productionTip = false;
// Vue.use(SmdScaffolding);

Vue.use(VueResize);
Vue.use(VueClickOutside);
Vue.use(MQ);
Vue.use(VuejsDialog);
Vue.use(Toasted, {
  theme: 'toasted-primary',
  position: 'top-center',
  duration : 5000,
  action : {
    text : 'CLOSE',
    onClick : (e, toastObject) => {
      toastObject.goAway(0);
    }
  }
});


new Vue({
  render: h => h(App),
  router: Router,
  store: Store,
  mq: {
    mobile: '(max-width: 767px)',
    tablet: '(min-width: 768px) and (max-width: 1023px)',
    desktop: '(min-width: 1024px)',
    tablet__up: '(min-width: 850px)',
    tablet__down: '(max-width: 1023px)'
  }
}).$mount('#app');
